<template>
<div :set="dayInt = new Date().getDay()">   
    <div style="clear:both; margin-bottom:20px;"></div>
  <div class="row">
<br/>
    <div class="col" v-for="day in 7" :key="day">     
      <h3><span class="badge badge-secondary">{{getDayByInt(dayInt + day - 1)}}</span></h3>
      <div class="hour" v-for="hour in 24" :key="hour" :set="entries = getEventsForHourInDay((dayInt + day -1), (hour-1))">
        <!-- <h6 v-else class="text-muted">{{hour-1}}:00</h6> -->
        <div class="entry" v-for="entry in entries.reverse()" :key="entry.time">
        <h4>{{entry.title}}</h4>
        <h4><span class="badge badge-light">{{new Date(entry.time).toLocaleTimeString()}}</span></h4>
        <br/>
        <a target="_blank" class="btn btn-secondary" :href="entry.streamURL" :key="entry.streamURL" role="button">Stream Link</a>
        <br/>
        <span v-for="tag in entry.tags" :key="tag" class="badge badge-pill badge-dark">{{tag}}</span>
        <hr/>
      </div>
        </div>      
    </div>    
  </div>
  </div>
</template>

<script>
import timetable_json from '../data/timetable.json'
export default {
  name: 'Timetable',
  props: {
    category: String,
    weeklyView: Boolean
  },
  timetableJson: timetable_json,
  methods: {      
      getEventsForHourInDay: function(day, hour)
      {
        var modDay = day % 7;
          var events = timetable_json.entries.filter(function(entry){
            var dateTime = new Date(entry.time);
              return modDay == dateTime.getDay() && hour == dateTime.getHours();
          });
          return events;
      },
      getDayByInt: function(day)
      {
        day = day % 7;
        switch (day) {
          case 0:
          case 7:
            return "Sunday";
            case 1:
              return "Monday";
          case 2:
            return "Tuesday";
          case 3:
            return "Wednesday";
          case 4:
            return "Thursday";
          case 5:
            return "Friday";
          case 6:
            return "Saturday";        
          default:
            break;
        }
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.entry {
  margin-bottom: 15px;
}

.col {
  padding: 1px;
  border-style: 1px none solid gray;
}

.row {
  margin: 0;
}

.container {
  padding: 0;
}
</style>
